<template>
  <div>
    <el-select ref="brands" multiple v-model="brandId" @change="selectBrand" filterable :placeholder="brandPlaceholder">
      <el-option
        v-for="item in brands"
        :key="item.label"
        :label="item.label"
        :value="item.label">
      </el-option>
    </el-select>
  </div>
</template>

<script>
import Config from '../framework/configs/Config'
import BrandSeriesModel from '../framework/models/brandSeriesModel'
export default {
  name: 'brand-and-and-factory-select',
  data: function () {
    return {
      baseImageUrl: Config.imageUrl,
      datas: [],
      brandId: [],
      brands: [],
      seriesId: null,
      series: [],
      categories: [],
      categoriesIds: [],
      props: {
        label: 'name',
        value: 'id',
        children: 'datas'
      },
      brandPosition: null,
      seariesPosition: null,
      categoriesPosition: null,
      areaCode: []
    }
  },
  created: function () {
    this.loadBrands()
  },
  props: {
    categoriesMultiple: {
      type: Boolean,
      default: true
    },
    brandPlaceholder: {
      type: String,
      default: '请选择品牌'
    },
    seriesPlaceholder: {
      type: String,
      default: '请选择车系'
    },
    categoriesPlaceholder: {
      type: String,
      default: '请选择车型'
    }
  },
  methods: {
    setValue: function (assignedToTheBrand) {
      if (!assignedToTheBrand || assignedToTheBrand == 'null') {
        return
      }

      let assignedToTheBrandArray = JSON.parse(assignedToTheBrand)

      let brandId = []
      for (var i = 0; i < assignedToTheBrandArray.length; i++) {
        let item = assignedToTheBrandArray[i]
        brandId.push(item.name + ' - ' + item.factoryName)
      }
      this.brandId = brandId
    },
    selectBrand: function (brandId) {
      let _this = this

      if (!brandId) {
        return
      }

      // 获取品牌信息
      // let brandRefs = this.$refs['brands'];
      // let brandPosition = brandRefs.hoverIndex
      // let brandInfo = this.brands[brandPosition]

      // 获取品牌信息
      let categoriesArr = []

      let categories = this.brands
      let length = categories.length
      let categoriesIds = this.brandId
      for (var i = 0; i < length; i++) {
        let categorie = categories[i]
        let name = categorie['name']
        let factoryName = categorie['factoryName']

        let position = categoriesIds.indexOf(name + ' - ' + factoryName)
        if (position != -1) {
          categoriesArr.push(categorie)
        }
      }

      if (categoriesArr) {
        this.$emit('onChanged', categoriesArr)
      }
    },
    clear: function () {
      this.areaCode = []
      this.brandPosition = null
      this.seariesPosition = null
      this.seriesId = null
      this.brandId = null
    },
    loadBrands: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          let data = dataInfo.datas.data

          for (var i = 0; i < data.length; i++) {
            let item = data[i]
            item.label = item.name + ' - ' + item.factoryName
          }
          _this.brands = data
        }
      }

      BrandSeriesModel.selectBrandFactoryList(_this, listener)
    }
  }
}
</script>
